'use client';

import React, { useState, useEffect } from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import axios from "axios";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../ui/ToastContext";
import { API_URL } from "../../config";

export function PlaceCreateForm(): React.JSX.Element {
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [prod, setProd] = useState([]);
    const [userData, setUserData] = useState([]);
    const [Nume_prenume, setNume_prenume] = useState("");
    const [value, setValue] = React.useState<Option[] | null>(null);
    const [valueuser, setValueuser] = React.useState<OptionUser[] | null>(null);
    const [nameError, setnameError] = useState(false);
    const [logError, setlogError] = useState(false);
    const [pasError, setpasError] = useState(false);
    const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
    const getJwtFromCookies = () => {
        const cookies = document.cookie.split("; ");
        const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
        return tokenCookie ? tokenCookie.split("=")[1] : null;
    };
    //const token = getJwtFromCookies();

    const token = localStorage.getItem('jwtToken');


    useEffect(() => {
        const timer = setTimeout(() => {
            setShowGrid(false); // După 1 secundă, comutăm pe grid
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/district`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setProd(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/region`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setUserData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    interface Option {
        district_id: number;
        district_name: string;
    }

    const organizerOptions: Option[] = prod.map((role: Option) => ({
        district_id: role.district_id,
        district_name: role.district_name,
    }));

    interface OptionUser {
        region_id: number;
        region_name: string;
    }

    const organizerOptionsuser: OptionUser[] = userData.map((role: OptionUser) => ({
        region_id: role.region_id,
        region_name: role.region_name,
    }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        //////////////////////////////console.log(valueuser?.length)
        if (Nume_prenume === ""
            || !value || value.length === 0
        ) {
            setnameError(Nume_prenume === "" ? true : false);
            setpasError(!value || value?.length === 0 ? true : false);

            //////////////////////////////console.log("Error: Fields are empty or invalid.");
            return;
        }


        try {
            if (value && value.length > 0) {
                for (let producerId of value) {

                    //////////////////////////////console.log(producerId1.region_id);
                    //////////////////////////////console.log(producerId.district_id);
                    await axios.post(`${API_URL}/api/cities`, {
                        city_name: Nume_prenume,
                        district_id: producerId.district_id,

                    });

                }
            }

            handleClose();
            showToast({
                message: "Datele au fost salvate cu succes!",
                type: "success",
                icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
            });
        } catch (error) {
            console.error(error);
            showToast({
                message: "Eroare la inserarea datelor!",
                type: "error",
                icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
            });
        }
    };

    const handleClose = () => {
        navigate(-1); // Use navigate to go back
    };

    const handleChange = (e) => {
        setNume_prenume(e.target.value);
    };

    const isDarkMode = document.documentElement.classList.contains('dark');

    return (
        <div >
            {showGrid ? (
                <div className="flex flex-row gap-2">
                    <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
                    <div className="flex flex-col gap-2">
                        <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
                    </div>
                </div>
            ) : (
                <form
                    onSubmit={(event) => {
                        event.preventDefault();
                    }}
                >
                    <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                        <CardHeader subheader="Informatia poate fii modificata" title="Formular" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                        <Divider className="dark:bg-gray-400" />
                        <CardContent>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div className="relative">
                                    <label
                                        className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                    >
                                        Denumirea
                                    </label>
                                    <input
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${nameError ? 'border-red-500' : ''}`}
                                        type="text"
                                        name="firstName"
                                        placeholder="Denumirea"
                                        value={Nume_prenume}
                                        onChange={handleChange}
                                    />
                                    {nameError && <p className="text-red-500 text-sm">Denumirea este obligatorie.</p>}

                                </div>
                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10" >
                                        Raion
                                    </label>
                                    <Select
                                        options={organizerOptions}
                                        placeholder="Select raionul..."
                                        classNamePrefix="react-select"
                                        value={value}
                                        onChange={(selected) => {
                                            //////////////////////////////console.log("Selected value:", selected);
                                            setValue(selected ? [selected] : null); // Asigură-te că value este întotdeauna un array
                                        }}

                                        getOptionLabel={(e) => e.district_name}
                                        getOptionValue={(e) => String(e.district_id)}
                                        menuPortalTarget={document.body}

                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                padding: '0.5rem',
                                                borderRadius: '0.375rem',
                                                borderColor: pasError ? 'red' : '#424242',
                                                boxShadow: 'none',
                                                height: '3rem',
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Z-index mare pentru a depăși dialogul
                                                color: isDarkMode ? 'black' : base.backgroundColor,
                                            }),
                                            singleValue: provided => ({
                                                ...provided,
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                            })
                                        }}
                                    />
                                    {pasError && <p className="text-red-500 text-sm">Raionul este obligatoriu.</p>}

                                </div>


                            </div>
                        </CardContent>
                        <Divider className="dark:bg-gray-400" />
                        <CardActions sx={{ justifyContent: 'flex-end' }}>
                            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white" onClick={handleSubmit}>
                                <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                                <span className="//max-xs:sr-only">Salveaza detaliile</span>

                            </button>
                        </CardActions>
                    </Card>
                </form>
            )}
        </div>
    );
}
